import { type ProductStore } from "@store/product/product.store";

export const isRenewable = (productStore: ProductStore): boolean =>
    productStore.activePlan === "best-renewable";
